// Don't forget to load bootstrap js in your project
// Here, we load it in our app.js

// We could import PerfectScrollbar directly in the sidebar module
window.PerfectScrollbar = require("perfect-scrollbar/dist/perfect-scrollbar.min.js")

let Sidebar = require("./components/sidebar")

export { Sidebar }
